import { Route, UrlSegment, Router } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable()
export class PerformanceMarkerGuard {

  constructor(private router: Router) { }

  public canLoad(route: Route, segments: UrlSegment[]): boolean {
    const marker: string = route?.data?.performanceMarker;
    const path: string = segments?.reduce((acc: string, value: UrlSegment) => acc.concat(value.path + '/'), '');
    if (!marker) {
      console.error('Marker not found for ', path);
      return true;
    }
    window.performance.mark(marker);
    return true;
  }
}